import environment from '@app/environments/environment';
import * as models from '@app/models/index';
import axios, { AxiosResponse, CancelToken } from 'axios';
import * as queryString from 'query-string';

export class ReportService {
	private baseUrl = environment.apiGateway.apiUrl;
	private apiUrl = '';

	constructor() {
		this.apiUrl = this.baseUrl + 'Report/';
	}

	/**
	 *  Get Account Statement By Day Report
	 */
	public async getAccountStatementByDay(
		pageToken: string,
		startDate: Date,
		endDate: Date,
		cancelToken?: CancelToken
	): Promise<models.IPagedResult<models.IAccountStatementByDay>> {
		try {
			const url = this.apiUrl + 'AccountStatementByDay';
			const res = await axios.get<models.IPagedResult<models.IAccountStatementByDay>>(url, {
				cancelToken,
				params: {
					pageToken,
					startDate: startDate.toISOString(),
					endDate: endDate.toISOString(),
				},
				paramsSerializer: (params) => queryString.stringify(params),
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Get Daily Finance Report
	 */
	public async getDailyFinance(
		pageToken: string,
		startDate: Date,
		endDate: Date,
		cancelToken?: CancelToken
	): Promise<models.IPagedResult<models.IDailyMonthlyFinance>> {
		try {
			const url = this.apiUrl + 'DailyFinance';
			const res = await axios.get<models.IPagedResult<models.IDailyMonthlyFinance>>(url, {
				cancelToken,
				params: {
					pageToken,
					startDate: startDate.toISOString(),
					endDate: endDate.toISOString(),
				},
				paramsSerializer: (params) => queryString.stringify(params),
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Get Monthly Finance Report
	 */
	public async getMonthlyFinance(
		startDate: Date,
		endDate: Date,
		cancelToken?: CancelToken
	): Promise<models.IPagedResult<models.IDailyMonthlyFinance>> {
		try {
			const url = this.apiUrl + 'MonthlyFinance';
			const res = await axios.get<models.IPagedResult<models.IDailyMonthlyFinance>>(url, {
				cancelToken,
				params: {
					startDate: startDate.toISOString(),
					endDate: endDate.toISOString(),
				},
				paramsSerializer: (params) => queryString.stringify(params),
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Get account statement b day report
	 */
	public async exportAccountStatementByDayReport(
		startDate: Date,
		endDate: Date,
		cancelToken?: CancelToken
	): Promise<AxiosResponse<Blob>> {
		try {
			const url = this.apiUrl + 'AccountStatementByDay/Export';
			const res = await axios.get<Blob>(url, {
				cancelToken,
				responseType: 'blob',
				params: {
					startDate: startDate.toISOString(),
					endDate: endDate.toISOString(),
				},
				paramsSerializer: (params) => queryString.stringify(params),
			});
			return res;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Get daily finance report
	 */
	public async exportDailyFinanceReport(
		startDate: Date,
		endDate: Date,
		cancelToken?: CancelToken
	): Promise<AxiosResponse<Blob>> {
		try {
			const url = this.apiUrl + 'DailyFinance/Export';
			const res = await axios.get<Blob>(url, {
				cancelToken,
				responseType: 'blob',
				params: {
					startDate: startDate.toISOString(),
					endDate: endDate.toISOString(),
				},
				paramsSerializer: (params) => queryString.stringify(params),
			});
			return res;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Get daily finance report
	 */
	public async exportMonthlyFinanceReport(
		startDate: Date,
		endDate: Date,
		cancelToken?: CancelToken
	): Promise<AxiosResponse<Blob>> {
		try {
			const url = this.apiUrl + 'MonthlyFinance/Export';
			const res = await axios.get<Blob>(url, {
				cancelToken,
				responseType: 'blob',
				params: {
					startDate: startDate.toISOString(),
					endDate: endDate.toISOString(),
				},
				paramsSerializer: (params) => queryString.stringify(params),
			});
			return res;
		} catch (error) {
			throw error;
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/report.service.ts